import React, { Component } from 'react'
import { connect } from 'react-redux'


import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import MenuItem from 'material-ui/MenuItem'

import { dirtyRead } from 'selectors/common'
import { propertyTransactions } from 'selectors/transactions'

import Section from 'components/Section'
import TransactionList from './List'
import EntityAttachments from 'components/EntityAttachments'
import AddButton from 'components/AddButton'
import dataActions from 'actions/dataActions'
import Divider from 'material-ui/Divider'

let select = dirtyRead(
	(state, props) => {
		return ({
			sections: state.sections
		  , propertyTransactions: propertyTransactions(state, props.propertyID) || []
		})
	}
)

export class Transactions extends Component{
	render(){
		let { props } = this
		return(
			<Section
				id="property/transactions"
				title="Transactions"
				badge={props.propertyTransactions.length}
				rightButton={
					<AddButton>
						<MenuItem value="bill" object={{type:'transaction/bill'}} primaryText="Bill" />
						<MenuItem value="invoice" object={{type:'transaction/invoice', date: new Date()}} primaryText="Invoice" />
					</AddButton>
				}
			>
					<TransactionList propertyID={props.propertyID} />
			</Section>
		)
	}
}

export default connect(select, dataActions)(Transactions)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/transactions/index.js